import type { Property } from '~/core/entities/property';

import { PropertyPublicationStatus } from '~/core/entities/api/ApiProperty';

interface UseShortsEntryAvailabilityOptions {
	shouldAddRobotsMeta?: Ref<boolean>;
}

export function useShortsEntryAvailability(
	entryProperty: Ref<Property | null>,
	options: UseShortsEntryAvailabilityOptions = {}
) {
	const isEntryPropertyPublished = computed(
		() =>
			entryProperty.value?.publicationStatus ===
			PropertyPublicationStatus.PUBLISHED
	);
	const isUnavailableEntryState = computed(
		() => !!entryProperty.value && !isEntryPropertyPublished.value
	);
	const shouldAddRobotsMeta = computed(
		() =>
			isUnavailableEntryState.value &&
			(options.shouldAddRobotsMeta?.value ?? true)
	);

	const event = useRequestEvent();
	if (event && isUnavailableEntryState.value) {
		setResponseStatus(event, 410, 'Gone');
	}

	useHead({
		meta: computed(() =>
			shouldAddRobotsMeta.value
				? [
						{
							name: 'robots',
							content: 'noindex, nofollow'
						}
					]
				: []
		)
	});

	return {
		isEntryPropertyPublished,
		isUnavailableEntryState
	};
}
